import FilterTags from './FilterTags';
export default FilterTags;
